module.exports = __webpack_public_path__ + "static/img/icon-hotel-type1.d450d66a.png";